const FilerField = (state = {}, action) => {
  switch (action.type) {
    case 'GET_FIELD_TYPE': {
      return {
        ...state,
        field: action.payload,
      };
    }
    case 'SET_FIELD_DD_DATA': {
      return {
        ...state,
        choices: action.payload,
      };
    }
    case 'CLEAR_FIELDS': {
      return {
        ...state,
        field: {},
        choices: [],
      };
    }
    case 'SET_QUERY': {
      let { query } = { ...state };
      query = action.payload;
      return {
        ...state,
        query,
      };
    }
    case 'CLEAR_CHOICES': {
      return {
        ...state,
        choices: [],
      };
    }
    default: {
      return state;
    }
  }
};

export default FilerField;
